// Parameters and keys 
let key_pop=document.cookie.split('; ').find((row) => row.startsWith('_shopify_s='))?.split('=')[1];
let parameters = '?shop=' + Shopify.shop + '&key=' + key_pop;

var popIconAPI='https://ecomapp-dev-v2.s3.ap-south-1.amazonaws.com/Coin.png',popIcon='<img src="https://ecomapp-dev-v2.s3.ap-south-1.amazonaws.com/Coin.png" height="23px" width="23px" alt="POPcoins Logo">';

// get available coins API
const brandAPI=`http://prod.mypopcoins.com/api/get-brand?shop=${Shopify.shop}`;
const coinsAPI=`http://prod.mypopcoins.com/api/get-available-coins${parameters}`;
const lottieAnimation = '';
const rewardNameLottieAnimationLink = `Gyros Farm Rewards`;
// Popclub Elements 
const loginFlag=document.querySelector("#pop-club-login-flag");
const redeemPrice=document.querySelector("#pop-club-redeem-price");
const dataRedeem=document.querySelector("#pop-club-data-redeem");
const popBalance=document.querySelector("#pop-club-data-coins");

// Event Delegation
document.addEventListener('click', function (event) {
  const target = event.target;
  if (target === document.querySelector('.pop_club_cart input#buy-with-pop-coins')) {
    // Handle .pop_club_cart click
    document.querySelector('.upcart-cart a[href="/checkout"]')?.setAttribute('disabled','');
    popCartDrawerDisc();
  }
});

function removeDiscount() {
    document.cookie = "discount_code=; expires=Thu, 18 Dec 2000 12:00:00 UTC; path=/";
}

async function popCartDrawerDisc() {
  const popclub_cart_div = document.querySelector('.pop_club_cart');
  // Function to add a loading indicator
  function addLoader() {
    const checkoutButton = document.querySelector('.upcart-cart a[href="/checkout"]');
    if (checkoutButton) {
      checkoutButton.setAttribute('disabled', '');
    }
    popclub_cart_div.classList.add('loader');
  }
  // Function to remove the loading indicator
  function removeLoader() {
    const checkoutButton = document.querySelector('.upcart-cart a[href="/checkout"]');
    if (checkoutButton) {
      checkoutButton.removeAttribute('disabled');
    }
    popclub_cart_div.classList.remove('loader');
  }
  try {
    // Fetch cart data
    const cartData = await fetch('/cart.js').then(response => response.json());
    // Apply the discount code with loading indicators
    createPopDiscountCart(cartData, addLoader, removeLoader, popclub_cart_div);
  } catch (error) {
    console.error('Error in popCartPageDisc:', error);
    // Handle any errors that occur during cart data fetching or discount creation
  }

}


function updateCartData(currKey) {

  let updatenew = {
    'line': 0,
    'properties': { '__pop_id': currKey }
  }

  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(updatenew)
  })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });

}
// Brand & fetch coin API Calls 
const getBrandInfo=async()=>{
  try{ 
    document.querySelectorAll('.DiscountCodeBadge_close__256WN').forEach((el)=>el.click());
    await remove_discount();
    await fetch('/discount/CLEAR_DISCOUNT');
    const [P1,P2]=await Promise.all([fetch(brandAPI),fetch(coinsAPI)])
    const brand_data=await P1.json();
    const coin_data=await P2.json();
    redeemPrice.value=brand_data.issuance;
    dataRedeem.value=brand_data.redeem;
    loginFlag.value=coin_data.success;
    popBalance.value=coin_data.coins;

    sessionStorage.setItem('popMaxRedeem',brand_data.max_discount_per_order);
    
    popIconAPI = brand_data.popcoins_icon;
    popIcon = `<img src="${popIconAPI}" height="23px" width="23px" alt="POPcoins Logo">`;

    sessionStorage.setItem('popBrandData', JSON.stringify(brand_data));
    sessionStorage.setItem('popUserData', JSON.stringify(coin_data));
    
    PDPEarnCall();
    bottomStrip();
    // cartEarnCall();
   
   // PDP_BuyNow();
    // if(loginFlag.value == 'true'){
      PLPCoins();
    // }
   /*
    let drawerCheckbox = document.getElementById('buy-with-pop-coins-cart-drawer-checkbox');
    if(drawerCheckbox){
      // discount_clear();
      console.log('discount_clear');
      //cartEarnCall();
      if(loginFlag.value == 'true'){
        var removedicoutcode_bogo = $(".hs-content-quantity-price .hs-discount-promo");
        // Check if the element has a specific class
        if (removedicoutcode_bogo.hasClass("hs-discount-promo")) {
            $(".popcoinsConfiguration").css('display','none');
            drawerCheckbox.addEventListener('change',function(){
              drawerCheckbox.checked = false;
            });
          
          
        }else{
          $(".popcoinsConfiguration").css('display','flex');
          drawerCheckbox.checked = true;
        if(drawerCheckbox.checked == true){
          customCartCheckout();
        }
        drawerCheckbox.addEventListener('change',function(){
          cartEarnCall();
          if(this.checked == true){
            customCartCheckout();
          }else{
            discount_clear();
          }
        })
        }
      }
    }
    */
    let cartPageCheckBox = document.getElementById('buy-with-pop-coins-cart-page-checkbox')
     if(cartPageCheckBox){
       // discount_clear()
       // Define a threshold width for mobile devices
          const mobileScreenWidth = 768; // Adjust this value as needed
          
          // Get the current screen width
          var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
          // Check if the screen width is below the threshold for mobile devices
          if (screenWidth < mobileScreenWidth) {
            cartPageEarnCallmobile();
            } else {
            cartPageEarnCall(); 
            }      
       if(loginFlag.value == 'true'){   
         // var removedicoutcode_bogo = $(".t4s-cartPage__items .t4s-cart_discount_price");
      // Check if the element has a specific class
      // if (removedicoutcode_bogo.hasClass("t4s-cart_discount_price")) {
          // $(".popcoinsConfiguration").css('display','none');
      // }else{
          // $(".popcoinsConfiguration").css('display','flex');
          cartPageCheckBox.checked = true;
        if(cartPageCheckBox.checked == true && popBalance.value > 0){
            customCartCheckout();
           
          }
        cartPageCheckBox.addEventListener('change',function(){
          // Check if the screen width is below the threshold for mobile devices
          if (screenWidth < mobileScreenWidth) {
            cartPageEarnCallmobile();
            } else {
            cartPageEarnCall(); 
            }
          if(this.checked == true){
            customCartCheckout();
          }else{
            discount_clear();
          }
        })
        // }
         
       }
      } 
    
    if(window.location.href.includes('/cart')){
      openModalFromBottomstripe.style.display="none";
    }

    if(coin_data.success===true && window.location.href.includes('/products')===true){
      popUpdatePdp();
    }

    const cartData = (await fetch('/cart.js').then(response=>response.json()));
    const popCartDrawerDiv = document.querySelector('.pop_club_cart');
    updateEarnCallout(cartData, brand_data, coin_data);
    updateCartDrawerPop(popCartDrawerDiv,cartData,brand_data,coin_data);
   //   if(window.location.href.includes('/products')){
   //   pdp_buy_now(qty=1)
   // }
  }catch(err){
    console.log(err)
  };
}

const excludedProduct_mp = new Map();
function POPClubCartTotalValue(cartObj) {
    let cartTotal = 0;

    cartObj.items.forEach((line_item) => {
        if (excludedProduct_mp.has(line_item.product_id.toString()) === false) {
            cartTotal += ((line_item.final_price / 100) * (line_item.quantity));
        }
    });

    return (cartTotal);

}

// Cart Drawer Discount Coupon Create
async function createPopDiscountCart(cartData, addLoader, removeLoader, el) {
  try {
    // Removing the Coupon Code
    removeDiscount();

    // Enable Loader
    addLoader();

    const brandData = JSON.parse(sessionStorage.getItem('popBrandData'));
    const popUserData = JSON.parse(sessionStorage.getItem('popUserData'));

    const percRedeem = brandData.redeem;
    const coinBal = popUserData.coins;

    const currPopPrice = POPClubCartTotalValue(cartData);
    console.log(currPopPrice);

    const popMaxRedeem = parseInt(brandData.max_discount_per_order);    
    const currPopDisc = Math.min(Math.round((percRedeem / 100) * (currPopPrice)), coinBal, popMaxRedeem);

    const key = document.cookie.split('; ').find((row) => row.startsWith('_shopify_s='))?.split('=')[1];
    // const key = sessionStorage.getItem('popClubSession');

    const price = cartData.items_subtotal_price / 100;
    let variants = '';

    for (const dataVar of cartData.items) {
      variants += dataVar.variant_id + '-' + dataVar.quantity + ',';
    }

    const parameters = `?cart=${price}&shop=${Shopify.shop}&key=${key}&variants=${variants}`;
    let ch = el.querySelector('input#buy-with-pop-coins').checked;

    if (ch && price > 0) {

      el.querySelector('label#buy-with-pop-coins-label').innerHTML = `Rs. ${currPopDisc} | Saved Using <img src="${popIconAPI}" height="23px" width="23px" alt="POPcoins Logo">coins`;

      if (el.classList.contains('pop_club_cart')) {
        document.querySelector('.upcart-cart  a[href="/checkout"]').innerHTML = `Checkout • Rs. ${(price - currPopDisc).toFixed(2)}`;
      }

      else if (el.classList.contains('cart_page_popcoin')) {
        document.querySelector('#main-cart-footer .totals__subtotal-value').innerHTML = `Rs. ${(price - currPopDisc).toFixed(2)}`;
      }

      const response = await fetch('https://prodreplica.mypopcoins.com/api/get-coins-cart-discount' + parameters);

      if (response.ok) {
        const discData = await response.json();

        if (discData.success) {
          let date = new Date();
          date.setTime(date.getTime() + (60 * 60 * 1000));
          const expires = '; expires=' + date.toUTCString();
          document.cookie = "discount_code=" + discData.code + expires + '; path=/';
          // fetch(`/discount/${discData.code}`)
        } 
        else {
          // Handle API response indicating failure
          console.error('Failed to get discount data:', discData.error_message);
        }
      }
      else {
        // Handle HTTP error
        console.error('Failed to fetch discount data:', response.status, response.statusText);
      }
    }
    else {
      el.querySelector('label#buy-with-pop-coins-label').innerHTML = `Save Rs. ${currPopDisc} Using <img src="${popIconAPI}" height="23px" width="23px" alt="POPcoins Logo">coins`;
      removeDiscount();
      if (el.classList.contains('pop_club_cart')) {
        document.querySelector('.upcart-cart  a[href="/checkout"]').innerHTML = `Checkout • Rs. ${price.toFixed(2)}`;
      }
      else if (el.classList.contains('cart_page_popcoin')) {
        document.querySelector('#main-cart-footer .totals__subtotal-value').innerHTML = `Rs. ${price.toFixed(2)}`;
      }
    }

    setTimeout(()=>{
      removeLoader();
    }, 500);
  } catch (error) {
    console.error('Error in createPopDiscountCart:', error);
    // Handle any other unexpected errors
  }
}


function updateCartDrawerPop(popCartDrawerDiv, cartData, brandData, popUserData) {

    const percRedeem = brandData.redeem;
    const popMiniCartValue = parseInt((brandData.minimum_cart_value) ? brandData.minimum_cart_value : 0);

    let isAutoDisc = false;
    cartData.items.forEach((line_item) => {
        if (line_item.discounts.length > 0) {
            line_item.discounts.forEach((disc) => {
                if (disc.title.includes('PopShop') === false) {
                    isAutoDisc = true;
                }
            })
        }
    })

    let isBtnDisabled = true;
    if (popCartDrawerDiv != null) {
        if (isAutoDisc === false) {
            popCartDrawerDiv.classList.add('loader');
            if (popUserData.success == true) {
                if (popUserData.coins == 0) {
                    popCartDrawerDiv.querySelector('#buy-with-pop-coins').style.display = "none";
                    popCartDrawerDiv.querySelector('#buy-with-pop-coins-label').innerHTML = 'You have 0 POPcoins. Shop now & earn coins.';
                    popCartDrawerDiv.classList.add('zero-user');
                }
                else {

                    let cartTotal = POPClubCartTotalValue(cartData);
                    const popMaxRedeem = parseInt(brandData.max_discount_per_order);
                    let popCartDisc = Math.min(Math.round((percRedeem / 100) * cartTotal), popUserData.coins,popMaxRedeem);

                    if (popCartDisc <= 0 || popMiniCartValue > cartTotal) {
                        popCartDrawerDiv.querySelector('#buy-with-pop-coins').style.display = 'none';
                        popCartDrawerDiv.querySelector('#buy-with-pop-coins-label').innerHTML = '';
                        popCartDrawerDiv.classList.add('pop-club-hide');
                    }
                    else {
                        popCartDrawerDiv.querySelector('#buy-with-pop-coins').style.display = "block";
                        popCartDrawerDiv.querySelector('#buy-with-pop-coins-label').innerHTML = `Save Rs. ${popCartDisc} Using ${popIcon}coins`;

                        popCartDrawerDiv.querySelector('#buy-with-pop-coins').checked = false;
                        popCartDrawerDiv.classList.remove('pop-club-hide');

                        const isCartOpened = document.querySelector('.upcart-cart.styles_active__7AzVD');

                        if (isCartOpened && popCartDrawerDiv.querySelector('#buy-with-pop-coins').checked == false && popCartDisc > 0 && sessionStorage.getItem('popPdpAtc') === null) {
                            // popCartDrawerDiv.querySelector('#buy-with-pop-coins').click();
                            // Function to add a loading indicator
                            document.querySelector('.upcart-cart a[href="/checkout"]')?.setAttribute('disabled', '');
                            isBtnDisabled = false;
                            function addLoader() {
                                const checkoutButton = document.querySelector('.upcart-cart a[href="/checkout"]');
                                if (checkoutButton) {
                                    checkoutButton.setAttribute('disabled', '');
                                }
                            }
                            // Function to remove the loading indicator
                            function removeLoader() {
                                const checkoutButton = document.querySelector('.upcart-cart a[href="/checkout"]');
                                if (checkoutButton) {
                                    checkoutButton.removeAttribute('disabled');
                                }
                            }
                            popCartDrawerDiv.querySelector('#buy-with-pop-coins').checked = true;
                            createPopDiscountCart(cartData, addLoader, removeLoader, popCartDrawerDiv);
                            console.log('Auto-Checked');
                        }

                    }
                }
                popCartDrawerDiv.classList.remove('not-logged-in');
                popCartDrawerDiv.classList.remove('popclub-hide');
                popCartDrawerDiv.classList.remove('zero-user');

            }
            else {
                popCartDrawerDiv.querySelector('#buy-with-pop-coins').style.display = "none";
                popCartDrawerDiv.querySelector('#buy-with-pop-coins-label').innerHTML = `<span onclick="openModel()"><span class="underline">Click</span> & get upto ${brandData.redeem}% off using ${popIcon}coins</span>`;
                popCartDrawerDiv.classList.add('not-logged-in');
                // popCartDrawerDiv.classList.add('popclub-hide');
                popCartDrawerDiv.classList.remove('zero-user');
            }
            popCartDrawerDiv.classList.remove('loader');
            popCartDrawerDiv.classList.remove('hidden');
        }
        else {
            popCartDrawerDiv.classList.add('hidden');
        }

    }

    if (isBtnDisabled) {
        document.querySelector('.corner-widget-wrapper #checkout2')?.removeAttribute('disabled', '');
        document.querySelector('.corner-widget-wrapper #corner-cowi-cart-summary-card-cta-button')?.removeAttribute('disabled', '');
        document.querySelector('.corner-widget-wrapper #corner-cowi-cart-custom-html-below-cta a')?.removeAttribute('popdisabled', '');
    }

}

function popUpdatePdp(){
  if(loginFlag.value=='false'){
    popPdpDiv.classList.add('hidden');
    return;
  }
  const popPdpDiv = document.querySelector('.pdp_popcoin');
  const productPrice = parseInt(document.querySelector('#pop-club-product-detail').getAttribute('price'));
  
  if(popPdpDiv && window.location.href.includes('/products')===true){
    const percRedeem = parseInt(dataRedeem.value);
    const popCoinBal = parseInt(popBalance.value);
    const pdpQty = parseInt(document.querySelector('.product-form__quantity [name="quantity"]').value);
      
    const redeemPricePdp = Math.round(Math.min(((percRedeem/100)*productPrice*pdpQty),popCoinBal));

    if(redeemPricePdp>=0){
      popPdpDiv.querySelector('input#buy-with-pop-coins').checked = false;
      popPdpDiv.querySelector('input#buy-with-pop-coins').style.display = "block";
      popPdpDiv.querySelector('label#buy-with-pop-coins-label').innerHTML = `Save Rs. ${redeemPricePdp} Using POPcoins`;
      
      popPdpDiv.querySelector('input#buy-with-pop-coins').onchange = async (el) => {

        // Add Loader
        document.querySelectorAll('variant-radios label').forEach((currEl)=>currEl.setAttribute('disabled',''));        
        document.querySelectorAll('.product-form__quantity button').forEach((currEl)=>currEl.setAttribute('disabled',''));
        document.querySelector('.product-form__buttons .sr-headless-checkout')?.setAttribute('disabled','');
        popPdpDiv.querySelector('input#buy-with-pop-coins').setAttribute('disabled','');
        
        const elChecked = el.target.checked;

        const productPrice = parseInt(document.querySelector('#pop-club-product-detail').getAttribute('price'));
        const percRedeem = parseInt(dataRedeem.value);
        const popCoinBal = parseInt(popBalance.value);
        const pdpQty = parseInt(document.querySelector('.product-form__quantity [name="quantity"]').value);
    
        const redeemPricePdp = Math.round(Math.min(((percRedeem/100)*productPrice*pdpQty),popCoinBal));
        
        if(elChecked===false){
          popPdpDiv.querySelector('label#buy-with-pop-coins-label').innerHTML = `Save Rs. ${redeemPricePdp} Using POPcoins`;
          document.cookie = "discount_code=; expires=Thu, 18 Dec 2000 12:00:00 UTC; path=/";
        }
        else {
          popPdpDiv.querySelector('label#buy-with-pop-coins-label').innerHTML = `Rs. ${redeemPricePdp} | Saved Using POPcoins`;
          const popKey = document.cookie.split("; ").find((row) => row.startsWith("_shopify_s="))?.split("=")[1];
          const variantId = parseInt(document.querySelector('#pop-club-product-id').value);
          const parameters = `?cart=${productPrice*pdpQty}&shop=${Shopify.shop}&key=${popKey}&variants=${variantId}`;
          try {
            const response = await fetch(`https://prodreplica.mypopcoins.com/api/get-coins-cart-discount${parameters}`);
            if (response.ok) {
              const data = await response.json();
              let date = new Date();
              date.setTime(date.getTime() + (60 * 60 * 1000));
              const expires = '; expires=' + date.toUTCString();
              document.cookie = "discount_code=" + data.code + expires + '; path=/';
            } else {
              console.error('Failed to fetch discount code:', response.status, response.statusText);
            }
          } catch (error) {
            console.error('Error while fetching discount code:', error);
          }
        }
        // Remove Loader
        popPdpDiv.querySelector('input#buy-with-pop-coins').removeAttribute('disabled');
        document.querySelectorAll('variant-radios label').forEach((currEl)=>currEl.removeAttribute('disabled'));  
        document.querySelectorAll('.product-form__quantity button').forEach((currEl)=>currEl.removeAttribute('disabled')); 
        document.querySelector('.product-form__buttons .sr-headless-checkout')?.removeAttribute('disabled');
      };
      
      popPdpDiv.classList.remove('hidden');
    }
    else {
      popPdpDiv.classList.add('hidden');
    }
    
  }
  
}


/*
function pdp_buy_now(qty){
  if(loginFlag.value == 'true'){
   discount_clear();
   document.querySelector('.pdp_popcoin').classList.remove('hidden');
    document.querySelector('.pdp_popcoin #buy-with-pop-coins').classList.remove('hidden');
    let pdp_price = document.querySelector('#pop-club-product-detail').getAttribute('price');
    pdp_price = parseInt(pdp_price);
    let pdp_qty = 1;
    let pdp_curr_pop_price = Math.min(Math.ceil((pdp_price * dataRedeem.value) / 100) * qty, popBalance.value);
    let finalPrice_pdp = Math.min(Math.ceil(pdp_price * qty));
    let pdpLabel = document.querySelectorAll('.pdp_popcoin label#buy-with-pop-coins-label')
    if(pdp_curr_pop_price > 0){
      pdpLabel.forEach(function(el){
        // if($('.zero-coins').length != 0){el.classList.remove('zero-coins');}
        el.innerHTML = "Save Rs. " + pdp_curr_pop_price + " Using POPcoins " + lottieAnimation;
      })
      let checkBoxPdp = document.getElementById('buy-with-pop-coins');
      if(checkBoxPdp){
        checkBoxPdp.addEventListener('change',function(e){
          if(this.checked == true){
             pdpLabel.forEach(function(el){
              el.innerHTML = "Rs. " + pdp_curr_pop_price + " | Saved Using POPcoins " + lottieAnimation;
            })
            customBuyNowCheckout();
          }else{
            pdpLabel.forEach(function(el){
              el.innerHTML = "Save Rs. " + pdp_curr_pop_price + " Using POPcoins " + lottieAnimation;
            })
            discount_clear();
          }
        })
      }
    }else{
      pdpLabel.forEach(function(el){
        $('#buy-with-pop-coins').hide();
        // el.classList.add('zero-coins');
        //el.innerHTML = "You have 0 POPcoins. Shop now & earn coins." + lottieAnimation;
      })
    }
  }
}
*/
// PLP Price listing  
const PLPCoins=()=>{
  const popClubListing=document.querySelectorAll(".pop-club-listing");
  if(popClubListing.length && popBalance.value){
    popClubListing.forEach(el=>{
     let price = el.getAttribute("price");
      let redeemCoins = Math.round((dataRedeem.value / 100) * price);
      if(redeemCoins > popBalance.value && loginFlag.value == 'true') redeemCoins=popBalance.value;
       if (redeemCoins > 0) {
              let redeemPrice = Math.round(price - redeemCoins);
              let popHTML = "<p>or Rs. " + redeemPrice + ` + <span class='pop-img'><img src='${popIconAPI}'> </span> ` + redeemCoins + "</p>";
              el.innerHTML = popHTML;
            }
      if(redeemCoins == 0){
        el.style.display = "none";
      }
    })
  }
}

// PDP Earn Call 
const PDPEarnCall=(value)=>{
  const PDPEarnDiv=document.querySelector("#pop-club-product-detail");
  let PDPPrice=Math.floor(+PDPEarnDiv?.getAttribute("price"));
  if(PDPPrice>100){
    let modulePrice= PDPPrice % 100;
    let PriceValue=PDPPrice-modulePrice;
    let PDPEarnCoin=Math.round((redeemPrice.value/100)*PriceValue);
    if (PDPEarnCoin > 0) {
      if(value) PDPEarnCoin=PDPEarnCoin*value;
              popHTML = `<p id='product-issuance-msg'> Earn <span class='pop-img'> <img src='${popIconAPI}'> </span> ` + PDPEarnCoin + " on this product </p>";
              let productIssuanceMsg = document.getElementById("product-issuance-msg");
              if (productIssuanceMsg) {
                PDPEarnDiv.innerHTML = popHTML;
              } else {
                PDPEarnDiv.insertAdjacentHTML("afterbegin", popHTML);
              }
            }
  }
}



// Bottom Bar 

const bottomStrip=(btmcoins)=>{
  const popClubStripe=document.getElementById("popcoinBtnSpan");
  const PDPEarnDiv=document.querySelectorAll("#pop-club-product-detail");
  // if(!PDPEarnDiv.length){
    //Home page bottom strip
  if(loginFlag.value == 'true' && popBalance.value>0){
    let bottomCoins=popBalance.value;
    let popHTMLStripe = `<div class="popcoin_sec"><img width="30" height="30" src="${popIconAPI}">` + bottomCoins + '</div> | Shop and Earn POPcoins';
    popClubStripe.innerHTML = popHTMLStripe;
  }
  //Zero balance bottom strip
   if(loginFlag.value == 'true' && popBalance.value==0){
    let bottomCoins=popBalance.value;
    let popHTMLStripe = `<div class="popcoin_sec"><img width="30" height="30" src="${popIconAPI}">` + bottomCoins + '</div> | Shop and Earn POPcoins';
    popClubStripe.innerHTML = popHTMLStripe;
  }
   if(loginFlag.value == 'false'){
    let bottomCoins=popBalance.value;
    let popHTMLStripe = `<span class="rewards-title">Gyros Farm Rewards</span> <img src="${popIconAPI}" height="30" width="30" loading="lazy"> Get upto ${dataRedeem.value}% Off using POPcoins`;
    popClubStripe.innerHTML = popHTMLStripe;
  }
  document.querySelector('button#popcoinsBottomBtn[type="submit"]')?.removeAttribute('type');
}



// PDP Variant update 
//const PDP_PriceContainer=document.querySelector(".product-block.product-block--price");
const PDP_PriceContainer=document.querySelector(".product-block.product-block--price");
//const PDP_PriceContainer_Quick=document.querySelector(".modal--is-active .product-block.product-block--price");

//const PDP_PriceContainerquick=document.querySelector(".product-block.product-block--price");
const PDP_input_elm=document.querySelector(".t4s-form__product .t4s-product-form__qty .t4s-quantity-input");
const config_pop={
  childList: true, // observe direct children
  subtree: true, // and lower descendants too
  characterDataOldValue: true // pass old data to callback
}
let observer = new MutationObserver(PDP_VariantChange); //Mutation observer for Price change
if(PDP_PriceContainer) observer.observe(PDP_PriceContainer,config_pop);
function PDP_VariantChange(){
  // let VariantPrice;
  // if(VariantPrice =='undefined' )
  // {
  //     VariantPrice=PDP_PriceContainer.querySelector(".product__price .price_style_money")?.innerHTML.replace('').split("Rs.")[1];
  // }else{
  //   VariantPrice=PDP_PriceContainer.querySelector(".product__price.on-sale .price_style_money")?.innerHTML.replace(/,/g,'').split("Rs.")[1];
  // }
  const PDPEarnDiv=document.querySelectorAll("#pop-club-product-detail");
  //console.log('VariantPrice');
  //console.log(VariantPrice);
  //PDPEarnDiv[PDPEarnDiv.length-1]?.setAttribute("price",VariantPrice);
  let PDP_Price=Math.floor(+PDPEarnDiv[PDPEarnDiv.length-1]?.getAttribute("price"));
  let PDPQtyVal=Math.round(PDP_Price*1);
  let PDPUpdatedVal=Math.round((dataRedeem.value / 100) * PDPQtyVal);
  PDPEarnCall(1);
  // bottomStrip(PDPUpdatedVal); 
  //Varint Id update when Prod changes
  const PDP_Url=window.location.href;
  const PDP_VariantId=PDP_Url.split("variant=")[1];
  const popPDPInput=document.getElementById("pop-club-product-id");
  if(popPDPInput) popPDPInput.value=PDP_VariantId;
}


//Clear discounts from cookies
const discount_clear=()=>{
  remove_discount();
  document.cookie ='discount_code=; expires=Thu, 18 Dec 2020 12:00:00 UTC; path=/';
}
// discount_clear();


// setTimeout(function(){
//   let checkoutBtnCart = document.querySelectorAll('.hs-content-checkout-button .hs-checkout-purchase');
//   //let pdpCheckoutBtn = document.querySelector('.t4s-section-main-product  .t4s-product-form__buttons .shopify-payment-button__button');
//   // if(pdpCheckoutBtn){
//   //   pdpCheckoutBtn.addEventListener('click',function(){
//   //     let pdpCheckbox = document.getElementById('buy-with-pop-coins');
//   //     if(pdpCheckbox.checked == false &&  pdpCheckbox){
//   //       discount_clear();
//   //     }
//   //   })
//   // }
//   if(checkoutBtnCart){
//     checkoutBtnCart.forEach(function(el){
//       el.addEventListener('click',function(){
//         let checkboxChecked = document.getElementById('buy-with-pop-coins-cart-drawer-checkbox');
//         let cartCheckBox = document.getElementById('buy-with-pop-coins-cart-page-checkbox');
        
//         setTimeout(function(){
//           if(checkboxChecked.checked == false && checkboxChecked){
//             discount_clear();
//           }
//         },1000)
//         if( cartCheckBox.checked == false && cartCheckBox){
//           discount_clear();
//         }
//       })
//     })
//   }
// },1500);


//Creating elem
function create(el) {
  var d = document;
  var element = d.createElement(el);
  element.classList.add("manual-class");
  return element;
}

async function updateEarnCallout(cartData, brandData, popUserData) {
  try {

    // Function to calculate issue coins
    function calculateIssueCoins(price, quantity, issuance) {

      const priceValue = Math.floor(price);
      let roundedPrice = 0;
      if (priceValue > 19) {
        const modulePrice = priceValue % 20;
        roundedPrice = priceValue - modulePrice;
      }

      return Math.round((brandData.issuance / 100) * roundedPrice) * quantity;

    }

    function insertAfter(newNode, existingNode) {
      return new Promise((res, rej) => {
        res(existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling));
      })
    }

    // Function to create HTML for issue coins
    function createIssueCoinsHTML(issueCoins) {
      return `<p id="product-issuance-msg"> Earn <span class="pop-img"> <img src="${popIconAPI}" width="20" height="21"> </span> ${issueCoins}</p>`;
      // return `<p id='product-issuance-msg'> Earn <span class='pop-img'> <img src='${popIconAPI}' width='20' height='21'> </span> ${issueCoins} </p>`;
    }

    // Update Cart Drawer
    setTimeout(() => {
      document.querySelector(".upcart-cart")?.querySelectorAll(".Stack__item.Stack__item--fill").forEach((item, i) => {
        const price_len = (cartData['items'][i].price.toString().length) - 2;
        const quantity = cartData['items'][i].quantity;
        const price = parseInt(cartData['items'][i].final_price.toString().slice(0, price_len) + "." + cartData['items'][i].final_price.toString().slice(price_len));
        const issueCoins = calculateIssueCoins(price, quantity, brandData.issuance);
        const newstring = createIssueCoinsHTML(issueCoins);

        const oldItems = item.querySelectorAll(".manual-class");
        oldItems.forEach((old_item) => old_item.remove());

        if (issueCoins > 0) {
          insertAfter(create("div"), item.querySelector("a.upcart-product-title-link")).then(() => {
            item.querySelector(".manual-class").innerHTML = '';
            item.querySelector(".manual-class").innerHTML = newstring;
          });
        }
      });
    }, 500);

    // Update Cart Page
    // document.querySelectorAll("form#cart #main-cart-items tr.cart-item").forEach((item, j) => {
    //   const price_len = (cartData['items'][j].price.toString().length) - 2;
    //   const quantity = cartData['items'][j].quantity;
    //   const price = parseInt(cartData['items'][j].final_price.toString().slice(0, price_len) + "." + cartData['items'][j].final_price.toString().slice(price_len));
    //   const issueCoins = calculateIssueCoins(price, quantity, brandData.issuance);
    //   const newstring = createIssueCoinsHTML(issueCoins);

    //   const oldItems = item.querySelectorAll(".manual_class_cart__price_down");
    //   oldItems.forEach((old_item) => old_item.remove());

    //   if (issueCoins > 0) {
    //     insertAfter(create("div"), item.querySelector(".product-option")).then(() => {
    //       item.querySelector(".manual_class_cart__price_down").innerHTML = '';
    //       item.querySelector(".manual_class_cart__price_down").innerHTML = newstring;
    //     });
    //   }
    // });

  } catch (error) {
    console.error('Error in cartDatas:', error);
  }
}


const cartPagepopSubtotal=async(data)=>{

  let popHTML="Calculating your total cart value";
  const popCoinLabel=document.querySelectorAll("#buy-with-pop-coins-cart-page-label");
  const popCoinCheckbox=document.querySelectorAll("#buy-with-pop-coins-cart-page-checkbox");
  const subtotalValue=document.querySelectorAll(".custome_totle .totals__subtotal-value");
    let priceLength=(data['items_subtotal_price'].toString().length) - 2;
    let price=data['items_subtotal_price'].toString().slice(0, priceLength);
    let redeemCoins = Math.round((dataRedeem.value / 100) * price);
    if(redeemCoins > popBalance.value && loginFlag.value == 'true') redeemCoins=popBalance.value;
    let redeemPrice = Math.round(price - redeemCoins);
    let totalPrice=`${redeemPrice.toLocaleString()}.00`;
    let cartPrice=`${price.toLocaleString()}.00`;
     let parseValue = parseFloat(cartPrice);
  if(loginFlag.value=='true'){
    if(redeemCoins==0){
     // popCoinCheckbox.forEach(el=>el.classList.add("hidden"));
      popCoinCheckbox.forEach(el=>el.style.display = 'none');
      popCoinCheckbox.forEach(el=>el.checked=false);
      popHTML='You have 0 POPcoins. Shop now & earn coins' + lottieAnimation;
      subtotalValue.forEach(el=>el.innerHTML= "Rs. " + totalPrice);
    }else{
      popCoinCheckbox.forEach(el=>el.style.display = 'block');
      popCoinCheckbox[0].checked?popHTML=`Rs. ${redeemCoins } | Saved using POPcoins`+ lottieAnimation : popHTML=`Save Rs. ${redeemCoins} using POPcoins` + lottieAnimation;
      popCoinCheckbox[0].checked?subtotalValue.forEach(el=>el.innerHTML=`Rs. ${totalPrice}`) : subtotalValue.forEach(el=>el.innerHTML=`Rs. ${parseValue.toLocaleString()}`)
    }
  }else{
    popCoinCheckbox.forEach(el=>el.style.display = 'none');
    popHTML=`<span class="underline" onclick="openModel()"><strong><u>Click</u></strong> & get upto ${dataRedeem.value}% off using POPcoins</span>` + lottieAnimation;
  }
  popCoinLabel.forEach(el=>el.innerHTML=popHTML);
  const CartItemList = document.querySelectorAll(".cart-items .cart-item");
  const hideLabelCheckbox = document.querySelector('.popcoinsConfiguration');
  CartItemList.forEach(el => {
    if(el.querySelector('.cart-item__details .discounts .discounts__discount')){
      popCoinCheckbox.forEach(el=>el.checked=false);
      popCoinCheckbox.checked?subtotalValue.forEach(el=>el.innerHTML=`Rs. ${totalPrice}`) : subtotalValue.forEach(el=>el.innerHTML=`Rs. ${parseValue.toLocaleString()}`)
      hideLabelCheckbox.style.display = "none";
    }
  })
  
}
//CartPage desktop Earn Call
const cartPageEarnCall = async () => {
  try{
	const CartItemList = document.querySelectorAll(".cart-items .cart-item");
	function insertAfter(newNode, existingNode) { //Creates Earn call elem
		return new Promise((res, rej) => {
			res(existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling));
		})
	}
	const resp = await fetch(window.Shopify.routes.root + 'cart.js')
	var data = await resp.json();
   
	let i = 0;
     let currKey = document.cookie.split('; ').find((row) => row.startsWith('_shopify_s='))?.split('=')[1];
      if (data.items.length > 0) {
        if (!data.items[0].properties.__pop_id) {
          updateCartData(currKey);
        }
        else if (data.items[0].properties.__pop_id != currKey) {
          updateCartData(currKey);
        }
      }
	if (CartItemList.length > 0) {
        
		CartItemList.forEach(el => {
			if (data['items'].length) {
				let priceLength = (data['items'][i].final_price.toString().length) - 2;
				let quantity = data['items'][i].quantity;
				let price = data['items'][i].final_price.toString().slice(0, priceLength) + "." + data['items'][i].price.toString().slice(priceLength);
				if (price == ".0") {
					// let val = document.querySelectorAll(".CartItem__Price")[i].textContent.split(",").join("").split(" ")[1];
					// price = val;
					i++;
				}
				let priceValue = Math.floor(price);
				let roundedPrice = 0;
				if (priceValue.toString().length > 2) {
					let modulePrice = priceValue % 100;
					roundedPrice = priceValue - modulePrice;
				}
				let issueCoins = Math.round(((redeemPrice.value / 100) * roundedPrice) * quantity);
				if (issueCoins > 0) {
					let newstring = `<p id='product-issuance-msg'> Earn <span class='pop-img'> <img src='${popIconAPI}' width='20' height='21'> </span> ` + issueCoins + "</p>";
					if (el.querySelector(".cart-item .price_in_desktop") != null) {
						el.querySelectorAll(".manual-class").forEach((old_item) => {
							old_item.remove();
						});
					}
					const ex = el.querySelector(".price_in_desktop");
                  
					if (ex) {
                      
						insertAfter(create("div"), el.querySelector(".cart-items .cart-item .price_in_desktop  .cart-item__price-wrapper")).then(() => {
							el.querySelector(".cart-item  .manual-class").innerHTML = newstring;
                          
						})
						i++;
					}
				}
			}
		})
	}
  }catch(err){
    console.log(err);
  }finally{
    cartPagepopSubtotal(data);
  }
}
//CartPage mobile Earn Call
const cartPageEarnCallmobile = async () => {
  try{
	const CartItemList = document.querySelectorAll(".cart-items .cart-item");
	function insertAfter(newNode, existingNode) { //Creates Earn call elem
		return new Promise((res, rej) => {
			res(existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling));
		})
	}
	const resp = await fetch(window.Shopify.routes.root + 'cart.js')
	var data = await resp.json();
   
	let i = 0;
     
	if (CartItemList.length > 0) {
        
		CartItemList.forEach(el => {
			if (data['items'].length) {
				let priceLength = (data['items'][i].final_price.toString().length) - 2;
				let quantity = data['items'][i].quantity;
				let price = data['items'][i].final_price.toString().slice(0, priceLength) + "." + data['items'][i].price.toString().slice(priceLength);
				if (price == ".0") {
					// let val = document.querySelectorAll(".CartItem__Price")[i].textContent.split(",").join("").split(" ")[1];
					// price = val;
					i++;
				}
				let priceValue = Math.floor(price);
				let roundedPrice = 0;
				if (priceValue.toString().length > 2) {
					let modulePrice = priceValue % 100;
					roundedPrice = priceValue - modulePrice;
				}
				let issueCoins = Math.round(((redeemPrice.value / 100) * roundedPrice) * quantity);
				if (issueCoins > 0) {
					let newstring = `<p id='product-issuance-msg'> Earn <span class='pop-img'> <img src='${popIconAPI}' width='20' height='21'> </span> ` + issueCoins + "</p>";
					if (el.querySelector(".cart-item .price_in_mobile") != null) {
						el.querySelectorAll(".manual-class").forEach((old_item) => {
							old_item.remove();
						});
					}
					const ex = el.querySelector(".price_in_mobile");
                  
					if (ex) {
                      
						insertAfter(create("div"), el.querySelector(".cart-items .cart-item .price_in_mobile .add_pop_coin_box")).then(() => {
							el.querySelector(".cart-item  .manual-class").innerHTML = newstring;
                          
						})
						i++;
					}
				}
			}
		})
	}
  }catch(err){
    console.log(err);
  }finally{
    cartPagepopSubtotal(data);
  }
}
// Cart Default checkout 
const cartPopCheckout=async()=>{
  try{
    const resp = await fetch(window.Shopify.routes.root + 'cart.js')
	const data = await resp.json();
    let priceLength = (data['items_subtotal_price'].toString().length) - 2;
    let price = data['items_subtotal_price'].toString().slice(0, priceLength) + "." + data['items_subtotal_price'].toString().slice(priceLength);
    let variants = '';
      for (let i = 0; i < data['items'].length; i++) {
        variants += data['items'][i]['variant_id'] + '-' + data['items'][i]['quantity'] + ',';
      }
    let cartParams=`?cart=${price}&shop=${Shopify.shop}&key=${key_pop}&variants=${variants}`;
    const cartUrl=`http://prod.mypopcoins.com/api/get-coins-cart${cartParams}`;
    const pop_resp=await fetch(cartUrl);
    const pop_data=await pop_resp.json();
    const originalString = pop_data.url;
    const findString = 'https://polishmeprettyindia.myshopify.com';
    const replaceString = 'https://www.polishmepretty.in';
    const updatedString = originalString.replace(findString, replaceString);
    pop_data.success==true?window.location = updatedString:openModel();
  }catch(err){
    console.log(err)
  }
}
async function remove_discount() {
	try {
		let key = document.cookie.split('; ').find((row) => row.startsWith('_shopify_s='))?.split('=')[1];
		let parameters1 = '&shop=' + Shopify.shop + '&key=' + key;
		const response = await fetch('http://prod.mypopcoins.com/api/remove-discount-code?' + parameters1).then((response) => response.json()).then(data => {
			if (data.success) {
				console.log("discount_deleted");
			}
		}).finally(() => {
			const simpl_btns = document.querySelectorAll(".custom-chckout");
			simpl_btns.forEach(el => el.disabled = false);
            const simpl_btns2 = document.querySelectorAll('.drawer-custom');
            simpl_btns2.forEach(el => el.disabled = false);
			// const simpl_btnsPDP = document.querySelector(".shopify-payment-button__button");
			// if (simpl_btnsPDP) simpl_btnsPDP.disabled = false;
		})
	} catch (err) {
		console.log(err)
	}
}
function getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null; // or return undefined
}


// Cart drawer third party checkout
const customCartCheckout=async()=>{
    try{
        //const simpl_btns = document.querySelectorAll(".hs-content-checkout-button .hs-checkout-purchase");
        const simpl_btns_cart = document.querySelectorAll(".cart__ctas .cart__checkout-button");
        
        // setTimeout(function(){
          
          simpl_btns_cart.forEach(el => {
            el.disabled = true;
            el.style.opacity = "0.5";
          });
          
        //   console.log('opacity set to 0.5');
        // }, 100);
      
      const resp = await fetch(window.Shopify.routes.root + 'cart.js')
      const data = await resp.json();
      let priceLength = (data['items_subtotal_price'].toString().length) - 2;
      let price = data['items_subtotal_price'].toString().slice(0, priceLength) + "." + data['items_subtotal_price'].toString().slice(priceLength);
      let variants = '';
        for (let i = 0; i < data['items'].length; i++) {
          variants += data['items'][i]['variant_id'] + '-' + data['items'][i]['quantity'] + ',';
        }
      let cartParams=`?cart=${price}&shop=${Shopify.shop}&key=${key_pop}&variants=${variants}`;
      const cartUrl=`http://prod.mypopcoins.com/api/get-coins-cart-discount${cartParams}`;
      const pop_resp=await fetch(cartUrl);
      const pop_data=await pop_resp.json();
      let now = new Date();
      let time = now.getTime();
      time += 3600 * 1000;
      now.setTime(time);
      document.cookie = `discount_code=${pop_data.code};expires=${now.toUTCString()};path=/`;
       setTimeout(function(){
         
         simpl_btns_cart.forEach(el => {
            el.disabled = false;
            el.style.opacity = "1";
          });
      }, 1500);
  }catch(err){
    console.log(err)
  }
}

//Open loaded iframe
let modal = document.getElementById('popcoinsIframeModal');
function openModel(){
  modal.style.display = 'block';
  document.body.classList.add('popcoinShow');
}
let popcoinsModalCloseBtn = document.getElementById('popcoinsModalCloseBtn');
popcoinsModalCloseBtn.addEventListener("click", function () {
  modal.style.display = "none";
  document.body.classList.remove("body", "popcoinShow");
   getBrandInfo();
});
let openModalFromBottomstripe = document.getElementById('popcoinsBottomBtn');
openModalFromBottomstripe.addEventListener('click',function(){
   setTimeout(function(){
    
  // openModel();
  if (document.querySelector("#popcoinsIframe").src.toString().includes('-cart') == true) {
   preLoadIframe(false);
     openModel();
  }
  else {
    openModel();
  }
  },700);
})

//  click  drawer popup


/* preload iframe */
function preLoadIframe(isCart = false){
  let key = document.cookie
    .split('; ')
    .find((row) => row.startsWith('_shopify_s='))
    ?.split('=')[1];
let modals = document.getElementById("popcoinsIframeModal");
modals.style.opacity = 1;
document.body.classList.add('popcoinShow');
if (window.location.href.indexOf("/products/") != -1) {
    var redeemPrices = document.getElementById("pop-club-redeem-price").value;
    let redeemCoins = redeemPrices;
    let iframeURL = document.getElementById("pop-club-iframe-url").value;
    document.getElementById('popcoinsIframe').src = iframeURL + "&key=" + key + "&page=pdp&discount=" + redeemCoins + '&url=' + window.location.href + ((isCart)?'-cart':'');
} else {
    let cartPage = "";
    if (window.location.href.indexOf("/cart") != -1) {
        cartPage = "&page=cart";
    }
    let iframeURL = document.getElementById("pop-club-iframe-url").value;
    document.getElementById('popcoinsIframe').src = iframeURL + "&key=" + key + cartPage + '&url=' + window.location.href + ((isCart)?'-cart':'');
}
  console.log("iframe loaded");
  body.removeEventListener("mousemove",loadIframe);
  body.removeEventListener("touchstart",loadIframe);
}
const body=document.querySelector("body");
function loadIframe(){
 preLoadIframe(); 
}

// PDP Qty Change Function
function pdpQty_change(el) {
  el.addEventListener('change', function (el) {
    document.cookie = "discount_code=; expires=Thu, 18 Dec 2000 12:00:00 UTC; path=/";
    const popPdpDiv = document.querySelector('.pdp_popcoin');

    const isLogin = loginFlag.value;
    const percRedeem = parseInt(dataRedeem.value);
    const coinBal = parseInt(popBalance.value);
    const currQty = parseInt(el.target.value);

    const productPrice = parseInt(document.querySelector('#pop-club-product-detail').getAttribute('price'));
    const currProdPrice = Math.min(Math.round((percRedeem / 100) * productPrice * currQty), coinBal);

    if (currProdPrice > 0 && isNaN(currProdPrice) === false) {
      popPdpDiv.querySelector('#buy-with-pop-coins-label').innerHTML = `Save Rs. ${currProdPrice} Using POPcoins`;
      popPdpDiv.querySelector('#buy-with-pop-coins').checked = false;
    }

  });
}

function popPdpQtyFix(){
  document.querySelectorAll('.product-form__quantity [name="quantity"]').forEach((currQtyEl)=>pdpQty_change(currQtyEl));
}

document.addEventListener("DOMContentLoaded",()=>{

  window.upcartOnCartLoaded=function(){
    typeof(getBrandInfo) && getBrandInfo();
  }

  window.upcartOnCartUpdated=function(){
    document.querySelector('.pop_club_cart')?.classList.add('hidden');
    typeof(getBrandInfo) && getBrandInfo();
  }
  
  setTimeout(function(){
    getBrandInfo();
    addPopcoinsInMenu()
    PDPEarnCall();
    popPdpQtyFix();
  },200);
})
body.addEventListener("mousemove",loadIframe);
body.addEventListener("touchstart",loadIframe);

function addPopcoinsInMenu() {
  // if($('.desktopmenu').length == 0){
  // desktop menu
    
    let desktop_nav = document.querySelector(".header__inline-menu .list-menu");
  if(desktop_nav){
    
    let li_menu = document.createElement("li");
    li_menu.setAttribute("class", "popcoinsMenu desktopmenu  ");
  
    let menu = document.createElement("a");
    menu.setAttribute(
      "class", 
      "header__menu-item list-menu__item link link--text focus-inset"
    );
    menu.setAttribute("onclick", "openModel()");

    let menuSpan = document.createElement("span");
    menuSpan.setAttribute(
      "class",
      "custom_span"
    );
    menuSpan.innerHTML = rewardNameLottieAnimationLink;
    menu.appendChild(menuSpan);
    li_menu.appendChild(menu);
    desktop_nav.appendChild(li_menu);
  }
   //}
  // mobile menu
//if($('.mobile_menubox').length == 0){
  let mobile_nav = document.querySelector(".menu-drawer__navigation .menu-drawer__menu");
  if(mobile_nav){
    let mobile_li_menu = document.createElement("li");
    mobile_li_menu.setAttribute("class", "popcoinsMenu mobile_menubox  ");
  
    let menu_mob = document.createElement("a");
    menu_mob.setAttribute(
      "class",
      "menu-drawer__menu-item list-menu__item link link--text focus-inset"
    );
    menu_mob.setAttribute("onclick", "openModel()");
    let menuSpan_mob = document.createElement("span");
    menuSpan_mob.setAttribute(
      "class",
      "custom_span"
    );
    menuSpan_mob.innerHTML = rewardNameLottieAnimationLink;
    menu_mob.appendChild(menuSpan_mob);
    mobile_li_menu.appendChild(menu_mob);
    mobile_nav.appendChild(mobile_li_menu);
    const listItems = mobile_nav.getElementsByTagName('li');
    const secondLastListItem = listItems[listItems.length - 11];
    
      if (secondLastListItem) {
      // Append the new list item to the second-to-last list item
      secondLastListItem.insertAdjacentElement('afterend', mobile_li_menu);
    }
  }
   //}
}
 // $('.snize-pagination').on('click',function(){
 //     console.log('hello');
 //    setTimeout(function(){
 //      if($('.custom_collection_pop_pop').length ==0){
        
 //      $( ".snize-product" ).each(function( index ) {
 //        var price = $(this).find('.snize-price').text();
 //        var popProdPrice = $.trim(price).replace(/ /g,'').split("Rs.")[1].replace(/,/g, '');
 //        $(this).find('.snize-price-list').after('<div class="custom_collection_pop_pop"><div class="pop-club-listing" price="'+popProdPrice+'"></div></div>');
 //      });
 //      getBrandInfo()
 //      }
 //    },1500)
 //  })
// $(document).ready(function(){
//   $('.snize-filter-button').on('click',function(){
//     setTimeout(function(){
//   if($('.custom_collection_pop_pop').length ==0){
    
//   $( ".snize-product" ).each(function( index ) {
//     var price = $(this).find('.snize-price').text();
//     var popProdPrice = $.trim(price).replace(/ /g,'').split("Rs.")[1].replace(/,/g, '');
//     $(this).find('.snize-price-list').after('<div class="custom_collection_pop_pop"><div class="pop-club-listing" price="'+popProdPrice+'"></div></div>');
//   });
//   getBrandInfo()
//   }
// },1500)
//   })
// })
// $(document).ready(function(){
//   setTimeout(function(){
//     var popdiscount_text = $('.hs-discount-promo .hs-discount-app-cart').text();
//     var containe_text = "PopShop";
//     if(popdiscount_text.indexOf(containe_text) != -1){
//       $('.hs-discount-promo').css('display','blcok');
//     }
//   },1000)
//   });

// $(document).on('click','.cart__item-sub .js-qty__wrapper',function(){
//   let drawerCheckiBox = document.getElementById('buy-with-pop-coins-cart-drawer-checkbox');
//   setTimeout(function(){
//     console.log('hey tehre')
//     drawerCheckiBox.checked = false;
//   },2000);
// })


setTimeout(function(){
  let discountAvailability = document.querySelector('.template-cart');
  if(discountAvailability){
      discountAvailability.addEventListener('click',function(){
        setTimeout(function(){
          let apllyVoucher = document.querySelector('.apply_voucher_btn');
          if(apllyVoucher){
            apllyVoucher.addEventListener('click',function(){
              setTimeout(function(){
                const hideLabelCheckbox = document.querySelector('.popcoinsConfiguration');
                const checkifShowDiscount = document.querySelector('.discountify_tag');
                let checkBoxUncheck = document.getElementById('buy-with-pop-coins-cart-page-checkbox');
                  if(checkifShowDiscount){
                    // hideLabelCheckbox.style.display = "none";
                     $('.popcoinsConfiguration').hide()
                     checkBoxUncheck.checked = false;
                      cartPageEarnCall();
                      cartPageEarnCallmobile();
                     discount_clear();
                  }
              },3500);
            })
          }
        },100);
      })


    let dscnt_manual_applybtn = document.querySelector('.dscnt_manual_applybtn');
    if (dscnt_manual_applybtn) {
      
      dscnt_manual_applybtn.addEventListener('click', function() {
        setTimeout(function() {
          console.log('i am here');
          var removedicoutcode_bogo = $(".discountify_tag .dis_tot_main");
          let checkBoxUncheck = document.getElementById('buy-with-pop-coins-cart-page-checkbox');
          // Check if the element has a specific class
          if (removedicoutcode_bogo.hasClass("dis_tot_main")) {
            checkBoxUncheck.checked = false;
            cartPageEarnCall();
            cartPageEarnCallmobile();
            $(".popcoinsConfiguration").css('display', 'none');
          } else {
            $(".popcoinsConfiguration").css('display', 'flex');
          }
        }, 3500);
      });
    }
 

    
  }
 
},1800);
setTimeout(function(){
    const hideLabelCheckbox1 = document.querySelector('.popcoinsConfiguration');
    const checkifShowDiscount1 = document.querySelector('.discountify_tag');
    let checkBoxUncheck = document.getElementById('buy-with-pop-coins-cart-page-checkbox');
   if(checkifShowDiscount1){
       $('.popcoinsConfiguration').hide()
       checkBoxUncheck.checked = false;
        cartPageEarnCall(); 
       cartPageEarnCallmobile();
       discount_clear();
    }
},2500)
$(document).on('click','.cpn_tag_close',function(){
  const CartItemList = document.querySelectorAll(".cart-items .cart-item");
  const hideLabelCheckbox = document.querySelector('.popcoinsConfiguration');
  CartItemList.forEach(el => {
    if(el.querySelector('.cart-item__details .discounts .discounts__discount')){
      $('.popcoinsConfiguration').hide()
    }else{
      $('.popcoinsConfiguration').show()
    }
  })
  
})
function getCookie(cookieName) {
  const name = cookieName + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');
  
  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return null; // Return null if the cookie is not found
}
$(document).on('click','#checkout',function(e){
  e.preventDefault();
  let checkBoxUncheck = document.getElementById('buy-with-pop-coins-cart-page-checkbox');
  if (checkBoxUncheck.checked == true) {
    window.location.href = "/checkout?discount="+getCookie("discount_code")
  }else{
    window.location.href = "/checkout";
  }
})



